import Promotions from "../core/promotions/Promotions";
import {useParams} from "react-router-dom";
import {unsubscribeByEmail} from "../../api/customer";
import {useQuery} from "@tanstack/react-query";

export default function UnsubscribeByEmail() {
    const {customerId, hash} = useParams()

    const {data, status, error} = useQuery({
        queryKey: ['unsubscribe-by-email', customerId, hash],
        queryFn: () => unsubscribeByEmail(customerId || '', hash || ''),
        enabled: !!(customerId && hash),
        retry: false
    });

    return (<main>
            <section style={{margin: '200px 0'}}>
                <div className="container-fluid text-center">
                    {status === 'success' && data?.status && (
                        <>
                            <h1>Вы успешно отписались от рассылки</h1>
                            <div><a href="/">Перейти к покупкам</a></div>
                        </>
                    )}
                    {(status === 'error' || (status === 'success' && !data?.status)) && (
                        <>
                            <h1>В процессе выполнения произошла ошибка</h1>
                            {error && (
                                <div className=" mt-3 text-danger">
                                    Детали ошибки: {(error as any).response?.data?.message || (error as any).response?.data?.detail || 'Неизвестная ошибка'}
                                </div>
                            )}
                        </>
                    )}
                    {(!customerId || !hash) && (
                        <>
                            <h1>В процессе выполнения произошла ошибка</h1>
                            <div className="text-muted mt-3">
                                <small>Не указаны необходимые параметры</small>
                            </div>
                        </>
                    )}
                    {status === 'pending' && customerId && hash && (
                        <h1>Обрабатываем запрос...</h1>
                    )}
                </div>
            </section>
        </main>
    )
}